const STORAGE_KEY = 'dealzy_selected_city';

export function getSelectedCityName() {
    try {
        return localStorage.getItem(STORAGE_KEY) || null;
    } catch {
        return null;
    }
}

export function setSelectedCityName(name) {
    try {
        if (name) localStorage.setItem(STORAGE_KEY, name);
    } catch { /* localStorage unavailable or full - ignore */ }
}

export function clearSelectedCityName() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch { /* ignore */ }
}
